exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._847rbySKRQJXT1cIxtiZa{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._847rbySKRQJXT1cIxtiZa{padding-left:0}html[dir=rtl] ._847rbySKRQJXT1cIxtiZa{padding-right:0}._25mEHXnBrYd57BM3TFRtn9{font-size:12px}html[dir] ._25mEHXnBrYd57BM3TFRtn9{margin-top:2px}html[dir=ltr] ._25mEHXnBrYd57BM3TFRtn9{margin-left:0}html[dir=rtl] ._25mEHXnBrYd57BM3TFRtn9{margin-right:0}", ""]);

// exports
exports.locals = {
	"createCategoryButton": "_847rbySKRQJXT1cIxtiZa",
	"icon": "_25mEHXnBrYd57BM3TFRtn9"
};